import { Info, InfoIcon, Loader2 } from "lucide-react";

import { Folder, MediaSchema, SiteInfo, SpotInfoDisplaySchema } from './SpotSchema';
import { SpotSchema } from './SpotSchema';
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel
} from "@/components/ui/form"
import { Input } from "@/components/ui/input";
import { set, z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, useWatch } from "react-hook-form";
import { TextArea } from '../ui/textarea';
import { useEffect, useRef, useState } from 'react';
import { Popup } from "../common/Popup";
import { Templates } from "./Templates";
import { TemplateEditor } from "./TemplateEditor";
import { SpotPreview } from "./SpotPreview";
import { useApiFetch } from "@/helper/apiFetch";
import { useTranslate } from '@/helper/translate';
import { Upload, Download, LayoutTemplate, HardDrive, Database } from 'lucide-react';
import { SVGEditor, TemplateHandle } from './SVGEditor';
import React from 'react';
import { blobToDataURL } from '@/helper/sort';
import { useAuth } from "@/auth";
import { FolderComp } from "./Folder";

type SpotInfoProps = {
  spotId: string | null;
  customerId: string;
  orderId: string|null;
  allowTemplate: boolean;
  onClose: () => void;
  onChanged: (spot: SpotInfoDisplaySchema | null) => void;
};

export function SpotInfo({ spotId, customerId, orderId, allowTemplate, onClose, onChanged }: SpotInfoProps) {

  const apiFetch = useApiFetch();
  const { translate } = useTranslate();
  const { linkedCustomerId } = useAuth();
  var returnValue: SpotInfoDisplaySchema | null = null;
  const [showTemplateList, setShowTemplateList] = useState(false);

  const [showPopupRedlof, setPopupRedlof] = useState(false);
  const [showPopup, setPopup] = useState(false);
  const [mediaIndex, setIndex] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const [isFirstFile, setIsFirstFile] = useState(false);
  const [isLoadingRM, setIsLoadingRM] = useState(false);
  const [isUploadingFile, setIsUploadingFile] = useState(false);
const [notPossible, setNotPossible] = useState(false);
  const [fileSelectionList, setFileSelection] = useState<Folder[] | null>(null);
  const [expandedList, setExpandedList] = useState<string[] | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isPreview, setPreview] = useState(false);
  const [isUndo, setUndo] = useState(false);
  const [isChanged, setChanged] = useState(spotId == null || spotId == "");
  const [errorText, setError] = useState("");
  const [warningText, setWarning] = useState("");
  const [popupError, setPopupError] = useState("");
  const [sites, setSites] = useState<SiteInfo[]>([]);
  const form = useForm<z.infer<typeof SpotSchema>>({
    resolver: zodResolver(SpotSchema),
    defaultValues: {}
  });

  // const mediaFiles = form.watch("tbMediaFiles"); // subscribes to the array so it redraws after upload

  const fileInputRef = useRef<HTMLInputElement>(null);
  const editorRef = useRef<TemplateHandle>(null);

  const selectFile = async (redlof: boolean | null) => {

    if (redlof == null) {
      if (linkedCustomerId != "Admin")
        fileInputRef.current?.click();
      else setPopupRedlof(true);
    }
    else if (redlof == false)
      fileInputRef.current?.click();
    else {
      setIsLoadingRM(true);

      const res = await apiFetch(`/App/GetSpotSelection?customerId=${customerId}`, {
        method: "GET",

      });
      setIsLoadingRM(false);

      if (!res.ok) {
        const e = await res.text();
        setError("Failed to get spots: " + e);

      }
      else {
        const files = await res.json();
        console.log(files);
        setFileSelection(files as Folder[]);



      }

    }
  };





  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setError("");
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = "";

    if (file.size > 20 * 1024 * 1024) {
      setError(translate("ui.fileTooLarge"));
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      setWarning(translate("ui.fileWarning"));
    }


    const fd = new FormData();
    fd.append("file", file);

    setIsUploadingFile(true);
    try {
      const res = await apiFetch(`/App/PrepareMedia?type=Local&spotId=${form.getValues('spotId')}&customerId=${customerId}&orderId=${orderId??""}&aspectRatio=${form.getValues(`tbMediaFiles.${mediaIndex}.aspectRatio`)}`, { method: "POST", body: fd });

      if (res.ok) {
        var data = await res.json();
        const media = MediaSchema.parse(data.media);
        var indexUsed = mediaIndex;
       /* if (isFirstFile)//find mediaindex
        {
          let found = false;
          //loop through media files to find matching aspect ratio
          for (var i = 0; i < (form.getValues("tbMediaFiles") ?? []).length; i++) {
            if (form.getValues(`tbMediaFiles.${i}.aspectRatio`) == media.aspectRatio) {
              setIndex(i);
              indexUsed = i;
              found = true;
              break;
            }
          }
          if (!found)//no match, add new media file
          {
            var error = translate("ui.nomediaforaspectratio") + media.aspectRatio;
            setPopupError(error);
            return;
          }

          setIsFirstFile(false);


        }*/

        media.mediaFileId = form.getValues(`tbMediaFiles.${indexUsed}.mediaFileId`);
        form.setValue(`tbMediaFiles.${indexUsed}`, media, { shouldDirty: true, shouldTouch: true });
        if (form.getValues("spotName") == null || form.getValues("spotName") === "")
          form.setValue("spotName", file.name.substring(0, file.name.lastIndexOf(".")));
        await setSource(media, indexUsed);

        if(data.warnings != "")
          setWarning(data.warnings);
      }
      else {


        var error = await res.text();
        setPopupError(error);
        return;

      }
      setPopup(false);
      setPopupRedlof(false);
    }
    finally {
      setIsUploadingFile(false);
    }
   

  };

  



  const setSource = async (media: z.infer<typeof MediaSchema>, index: number) => {

    try {
      const res = await apiFetch(`/App/ServeImage?path=${encodeURIComponent(media.pathServer && media.mimeType?.startsWith("image") ? media.pathServer as string : media.snapshotPath as string)}`);
      if (!res.ok) throw new Error("Failed to fetch image");
      const url = await blobToDataURL(await res.blob());
      form.setValue(`tbMediaFiles.${index}.fileData`, url, { shouldDirty: true, shouldTouch: true });



    } catch (e) {
      console.error(e);
    }

  }


  const setSpotStatus = async (statusId: number) => {

    const res = await apiFetch(`/App/SetSpotStatus?spotId=${spotId}&statusId=${statusId}`, {
      method: "GET",

    });

    if (!res.ok) {
      const e = await res.text();
      setError("Request failed: " + e);

    }
    else {
      setError("");
      form.setValue('statusId', statusId, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
      //create a spotinfoDisplaySchema to return with updated status without refetching
      const displaySchema = {
        id: form.getValues("spotId") as string,
        name: form.getValues("spotName") as string,
        note: form.getValues("note") as string,
        isAutoGenerated: false,
        statusId: statusId,
        isSelected: false,
        isDeleted: false,
        mediaFile: null,
        error: ""
      };
      onChanged(displaySchema as SpotInfoDisplaySchema);

    }




  }
  const sourceClicked = (index: number) => {
    if (statusId != 1)
      return;

    setIndex(index);
    var templateId = form.getValues(`templateId`);
    if (templateId == null || templateId == "")
      selectFile(null);
    // else
    //  setTemplateEditor(templateId as string);
  }
  const updateStatus = (statusId: number, comment: string | null) => {

    //form.setValue("statusDescription", statusId == 3 ? "Approved" : statusId == 4 ? "Denied" : "Unknown");
    form.setValue("comment", comment);
    form.setValue('statusId', statusId, { shouldDirty: true, shouldTouch: true, shouldValidate: true });

    onChanged({
      id: form.getValues("spotId") as string,
      name: form.getValues("spotName") as string,
      note: form.getValues("note") as string,
      statusId: statusId,
      isAutoGenerated: false,
      isSelected: false,
      isDeleted: false,
      mediaFile: null,
      error: ""


    } as SpotInfoDisplaySchema);//force redraw of spot list
  }

  const download = async (index: number) => {

    const res = await apiFetch(`/App/ServeMedia/${form.getValues(`tbMediaFiles.${index}.mediaFileId`)}`)


    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`Download failed ${res.status}: ${text}`);
    }

    // Try to get a filename from Content-Disposition
    const dispo = res.headers.get("content-disposition") || "";
    const match = dispo.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
    const suggestedName = decodeURIComponent(form.getValues("spotName") ?? "file");

    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);

    // Create a temporary link and click it
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = suggestedName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobUrl);


  }
  const onSubmit = async (values: z.infer<typeof SpotSchema>) => {
    try {
      setIsSaving(true);

      setError("");
      if (editorRef.current != null) {


        editorRef.current?.Save().then(templateId => {
          if (templateId.startsWith("error")) {
            setIsSaving(false);
            setError(templateId.substring(5));
            return;
          }
          values.templateId = templateId;
          Save(values);

        }
        );
      }
      else {
        //we need every format (makes no sense to me but it's requested by benni)
        if (!form.getValues('templateId')) {
          for (const mf of form.getValues("tbMediaFiles") ?? []) {
            if (mf.fileData == null) {
              setError(translate("ui.allMediaFilesNeedUpload"));
              setIsSaving(false);

              return; // exits the parent function
            }
          }
        }


        Save(values);
      }

    } catch (err) {
      console.error(err);
    }
  }


  const Save = async (values: z.infer<typeof SpotSchema>) => {
    try {


      const fd = new FormData();
      //dont send fileURLs
      const payload = {
        ...values,
        tbMediaFiles: values.tbMediaFiles?.map(({ fileData, ...rest }) => rest),
      };

      fd.append("payload", JSON.stringify(payload));

      // for (const [name, f] of fileMapRef.current) {
      //   fd.append("files[]", f, name); // server can read f.name 
      // }
console.log("save spot:");
      const res = await apiFetch(`/App/SaveSpot`, { method: "POST", body: fd });

      setIsSaving(false);
      if (!res.ok) {
        console.error("Save failed", await res.text());
        const e = await res.text();
        setError(translate("ui.failedsave") + e);

      }
      else {
        const data = await res.json();
        onChanged(data as SpotInfoDisplaySchema);
      

          if(data.warnings && data.warnings != "")
          {
            setWarning(data.warnings);
          }
          else
          {
            //if spot is not approved, keep open to show approve button
            if( data.statusId == 1)
            {
            form.setValue("spotId", data.id);
            spotId = data.id;
            form.setValue("statusId", data.statusId);
            setChanged(false);
            
            }
            else
            onClose();
          }

      }
    } catch (err) {
      console.error(err);
      setIsSaving(false);
    }
  }


  const statusId = form.watch("statusId");

  useEffect(() => {




    apiFetch(`/App/GetSpot?spotId=${spotId}&customerId=${customerId}`)
      .then(res => {
        if (!res.ok) throw new Error("Failed to fetch");
        return res.json();
      })
      .then(data => {

        if(data.sites.length == 0 && (spotId == null || spotId == ""))//do not allow a new spot if no sites are available for this customer
        {
          setNotPossible(true);
          return;
        }
        //we need fileData property
        data.spot.tbMediaFiles.forEach((mf: any) => {
          mf.fileData = null;

        });
        form.reset(data.spot);
        setSites(data.sites);

        if (spotId == null || spotId == "") {
          setIsLoaded(true);
          if(allowTemplate) {
            setPopup(true);
          }
          //setIsFirstFile(true);//media format is NOT determined.
        }
        // else 
          {
          //load snapshots for media files
          data.spot.tbMediaFiles.forEach(async (mf: any, index: number) => {
            if (mf.aspectRatio == "16x9")
              setIndex(index);//default to 16x9 for new spot, SHOULD be 0 but can't guarantee order

            if (mf.snapshotPath && !mf.fileData) {
              try {
                // const res = await apiFetch(`/App/ServeImage?path=${encodeURIComponent(mf.snapshotPath)}`);
                // if (!res.ok) throw new Error("Failed to fetch image");
                // const url = await blobToDataURL(await res.blob());
                // form.setValue(`tbMediaFiles.${index}.fileData`, url, { shouldDirty: true, shouldTouch: true });

                await setSource(mf, index);
                //set after first is laoded
                setIsLoaded(true);

              } catch (e) {
                console.error(e);
              }
            }
          });
        }

      })
      .catch(err => {
        console.error(err);

      });
  }, []);


  return (

    <div className="popCnt p-0">
      {!isLoaded ? (
        <div className="w-full text-center my-10">{translate(notPossible?"ui.notPossible":"common.loading")}</div>
      ) : (
        <div>
          <input
            type="file"
            accept=".png, .jpg, .jpeg, .mp4"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          {!showPopup && (
            <Form {...form}>

              <div className="space-y-2">

              <div className="bg-white dark:bg-zinc-600 rounded-2xl shadow-lg space-y-4 mx-[-10px] my-1 px-3 py-4">


                <div className="grid gap-2 grid-cols-3">
                  <FormField
                    control={form.control}
                    name="spotName"
                    render={({ field }) => (
                      <FormItem className="col-span-2">
                        <FormLabel>{translate("ui.name")}</FormLabel>
                        <FormControl>
                          <Input {...field} disabled={statusId !== 1} />
                        </FormControl>
                      </FormItem>
                    )}
                  />




                  <div>
                    {spotId && (
                      statusId === 1 ? (
                        <div className="ml-6 text-sm font-medium">
                          <span className="absolute top-0 right-[5rem] spotStatus1 px-5 py-3 rounded-b-md shadow-sm shadow-gray-400 text-base">
                            {translate("ui.status_" + form.getValues("statusId"))}
                          </span>
                          <Button
                            className="mt-[29px] px-6"
                            type="button"
                            variant="outline"
                            onClick={async () => await setSpotStatus(2)}
                          >
                            {translate("ui.submitForApproval")}
                          </Button>
                        </div>
                      ) : statusId === 4 ? (
                        (form.getValues("comment")?.length ?? 0) > 0 ? (
                          <div className="ml-6 text-sm font-medium">
                            <span className="absolute top-0 right-[5rem] spotStatus4 px-5 py-3 rounded-b-md shadow-sm shadow-gray-400 text-base">
                              {translate("ui.status_" + form.getValues("statusId"))}
                            </span>
                            <Button
                              className="mt-[29px] px-6"
                              type="button"
                              variant="outline"
                              onClick={() => setUndo(true)}
                            >
                              {translate("ui.undoApproval")}
                            </Button>
                            <br />
                            <span>{form.getValues("comment")}</span>
                          </div>
                        ) : (
                          <div className="ml-6 text-sm font-medium">
                            <span className="absolute top-0 right-[5rem] spotStatus4 px-5 py-3 rounded-b-md shadow-sm shadow-gray-400 text-base">
                              {translate("ui.status_" + form.getValues("statusId"))}
                            </span>
                            <Button
                              className="mt-[29px] px-6"
                              type="button"
                              variant="outline"
                              onClick={() => setUndo(true)}
                            >
                              {translate("ui.undoApproval")}
                            </Button>
                          </div>
                        )
                      ) : statusId === 2 ? (
                        <div className="ml-6 text-sm font-medium">
                          <span className="absolute top-0 right-[5rem] spotStatus2 px-5 py-3 rounded-b-md shadow-sm shadow-gray-400 text-base">
                            {translate("ui.status_" + form.getValues("statusId"))}
                          </span>
                          <Button
                            className="mt-[29px] px-6"
                            type="button"
                            variant="outline"
                            onClick={() => setUndo(true)}
                          >
                            {translate("ui.undoApproval")}
                          </Button>
                        </div>
                      ) : statusId === 3 ? (
                        <div className="ml-6 text-sm font-medium">
                          <span className="absolute top-0 right-[5rem] spotStatus3 px-5 py-3 rounded-b-md shadow-sm shadow-gray-400 text-base">
                            {(form.getValues("hasBookings") ) ? translate("ui.status_active") : translate("ui.status_" + form.getValues("statusId"))}
                          </span>
                          <Button
                            className="mt-[29px] px-6"
                            type="button"
                            variant="outline"
                            onClick={() => setUndo(true)}
                          >
                            {translate("ui.undoApproval")}
                          </Button>
                        </div>
                      ) : null
                    )}
                  </div>




                  <FormField
                    control={form.control}
                    name="note"
                    render={({ field }) => (
                      <FormItem className="col-span-3 note">
                        <FormLabel>{translate("ui.note")}</FormLabel>
                        <FormControl>
                          <TextArea {...field} disabled={statusId !== 1} />
                        </FormControl>
                      </FormItem>
                    )}
                  />

                </div>



                <div className="!mt-0">

                  {/* <div className="tabs">
                    {!form.getValues('templateId') && form.getValues('tbMediaFiles')?.map((media, index) => (
                      <span
                        key={index}
                        className={`tab ${index === mediaIndex ? 'active' : ''}`}
                        onClick={() => setIndex(index)}
                      >
                        {translate("ui.format")} {media.aspectRatio ? media.aspectRatio : "N/A"}
                      </span>
                    ))}
                  </div> */}

                  <div >




                    {form.getValues(`templateId`) ? (
                      <div className="grid-default" key="999">
                        <SVGEditor
                          ref={editorRef}
                          templateId={form.getValues(`templateId`) as string}
                          statusId={statusId}
                          customerId={customerId}
                          //aspectRatio={form.getValues(`tbMediaFiles.${mediaIndex}.aspectRatio`) as string} 
                          onChanged={() => {
                            setChanged(true);
                            form.setValue("statusId", 1);
                          }}>
                        </SVGEditor>
                      </div>

                    ) : (

                      <div className="mt-4 relative">
                        <div><b>Datenanlieferung/Produktionsvorlagen</b></div>
                   
                        <div className="border border-blue-300 rounded-lg p-4 infoBox">
                          {sites.find(s => s.name.startsWith("Augsburg")) == null ? (
                              <div><b className="text-blue-500">Abmessungen: </b><b>1024 x 576 Pixel</b><span> (Seitenverhältnis 16 : 9)</span></div>
                          ):(
                              <div><b className="text-blue-500">Abmessungen: </b><b>mind. 1024 x mind. 576 Pixel (Ideal für Augsburg: 1084x610)</b><span> (Seitenverhältnis 16 : 9)</span></div>
                          )}

                              {(form.getValues("tbMediaFiles")?.find(m => m.aspectRatio === "32x21")) && (
                                <div><span className='underline'>Bitten beachten: </span>Für den Standort <b>Ulm</b> wird noch <b>zusätzlich</b> das Format 32 : 21 <b>(1024 x 672 Pixel)</b> benötigt</div>
                              )}
                              <div className="mt-2"><b className="text-blue-500">Datenformate: </b><span>Animiert immer als <b>MP4</b>, als starre Folie im <b>JPG</b> oder <b>PNG</b> Format</span></div>  

                          </div>
                      <div className="flex flex-row gap-2 mt-5">

                      


                        {form.getValues('tbMediaFiles')?.map((media, index) => (
                          <div className="flex-1">
                      <span
                        key={index}
                       
                        
                      >
                        {media.aspectRatio == "16x9" ? <div><b>1024 x 576 Pixel</b> (16 : 9)</div> : media.aspectRatio == "32x21" ? <div><b>1024 x 672 Pixel</b> (32 : 21)</div> : media.aspectRatio}
                      </span>

                      <div className="grid-default " key={index}>
                       {/* {(form.getValues("tbMediaFiles") ?? []).length > 0 && (
                          // <div className="col-span-2">
                          //   {translate("ui.neededForOrders")}: <br />
                          //  {[...new Set(
                          //   (sites ?? [])
                          //     .filter(o => o.siteSettings?.some(s => s.aspectRatio === media.aspectRatio))
                              
                          // )].map((site, index) => (
                          //   (() => {
                          //     var siteSetting = site.siteSettings?.find(s => s.aspectRatio === media.aspectRatio);
                          //     return (
                          //       <div key={index}>
                          //         {site.name}  {`(${siteSetting?.minWidth} x ${siteSetting?.minHeight})`}
                          //       </div>
                          //     );
                          //   })()
                          // ))}
                          // </div>
                          
                        )}  */}
                        <div onClick={() => sourceClicked(index)} className={` ${(statusId == 1) ? 'cursor-pointer' : 'cursor-not-allowed'}`}>
                          {
                            (media.fileData == null) ? (
                              <div>
                                <Button type="button" variant="outline" className="h-[150px] aspect-[16/9] flex-col">
                                <div>  <Upload className="!w-[40px] !h-[40px]" strokeWidth={1.25}   /></div>
                                  <div>{translate("ui.selectFile")}</div>
                                  <div>MP4, JPG, PNG</div>
                                </Button>
                              </div>
                            ) : (

                              // form.getValues(`tbMediaFiles.${mediaIndex}.mimeType`)?.startsWith("video") && fileMapRef.current.get(String(form.getValues(`tbMediaFiles.${mediaIndex}.aspectRatio`))) ? (
                              //   <video
                              //     className="w-full "

                              //     src={form.getValues(`tbMediaFiles.${mediaIndex}.fileData`) ?? undefined}
                              //   />) : (
                              //   <video
                              //     className="w-full "

                              //     src={fileURL != null ? fileURL : `data:video/x-ms-wmv;base64,${form.getValues(`tbMediaFiles.${mediaIndex}.snapshot`)}`}
                              //   //src={`${API_BASE_URL}/App/ServeMedia?mediaFileId=${`tbMediaFiles.${mediaIndex}.mediaFileId`}`}
                              //   />) : (
                              //   <img
                              //     className="w-full  "
                              //     src={fileURL != null ? fileURL : `data:image/png;base64,${form.getValues(`tbMediaFiles.${mediaIndex}.snapshot`)}`}
                              //   />
                              // )
                              <div>
                              <img
                                className="w-[full]  "
                                src={media.fileData ?? undefined}// `data:image/png;base64,${snapshot}`}
                              />
                               {!isChanged && (
                              <Download size={32} className='-translate-y-[20px] cursor-pointer bg-sky-600 hover:bg-sky-700 dark:bg-orange-400 dark:hover:bg-orange-500 rounded-full p-[6px] text-white' aria-labelledby="dlTitle" onClick={() => download(index)}>
                                <title id="dlTitle">Download</title>
                              </Download>
                            )}
                              </div>
                              //)
                            )}


                        </div>
                        <div className="p-2">

                          <table>
                            <tr>
                              <td className="font-bold">{translate("ui.type")}</td>
                              <td className="px-4 ">{media.mimeType ?? "-"}</td>
                            </tr>
                            {(media.length ?? 0) > 0 && (
                            <tr>
                              <td  className="font-bold">{translate("ui.duration")}</td>
                              <td className="px-4 ">{media.length}</td>
                            </tr>)}
                            <tr>
                              <td  className="font-bold">{translate("ui.width")}</td>
                              <td className="px-4 ">{media.width ?? "-"}</td>
                            </tr>
                            <tr>
                              <td  className="font-bold">{translate("ui.height")}</td>
                              <td className="px-4 ">{media.height ?? "-"}</td>
                            </tr>
                          </table>

                           
                          </div>
                        </div>
                      </div>       ))}

                      </div>
                      </div>
              
                    )}



                  </div>


                </div>

                {warningText && (
                  <div className="text-red-500 mt-2 " style={{ whiteSpace: "pre-line" }}>
                    {warningText}
                  </div>
                )}
              </div>

                <div className="grid-default">
                  <div className="grid-default">{!isChanged && (

                    <Button className="w-full" type="button" onClick={() => { setPreview(true); }}>{translate("common.preview")}</Button>


                  )}</div>

                  <div className="flex flex-row gap-2 justify-end">

                    <Button className="w-full max-w-[17vw]" type="button" onClick={() => { console.log("Cancel clicked"); onClose(); }}>{translate("common.cancel")}</Button>
                    {form.getValues("statusId") == 2 ? null : (//don't let changes be made, we need the UOM to stay for approval email
                      // <Button className="w-full" type="submit">{isChanged ? translate("common.generate") : translate("common.save")}</Button>
                      <Button className="w-full primary" type="button" onClick={() => form.handleSubmit(onSubmit, (errors) => console.log("Validation errors:", errors))()}>
                        {isSaving && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />}
                        {translate("common.save")}
                      </Button>
                    )}
                  </div>
                </div>

              </div>
            </Form>

          )}
        </div>
      )}


      <Popup
        isOpen={showPopup}
        onClose={() => { if (!isUploadingFile) setPopup(false); }}
        title={translate("ui.choose")}
        className="w-[800px]"
      >
        {isUploadingFile ? (
          <div className="h-[150px] flex items-center justify-center gap-3 text-lg font-medium">
            <Loader2 className="h-6 w-6 animate-spin" aria-hidden="true" />
            Uploading, please wait...
          </div>
        ) : (
          <div className="grid-default tmpl1">

            <Button type="button" variant="outline" className="w-full h-[150px] flex flex-col" onClick={() => { setPopup(false); }}>
              <Upload className="!w-[40px] !h-[40px]" strokeWidth={1.25} />
              {translate("ui.uploadFile")}
            </Button>
            <Button type="button" variant="outline" className="w-full h-[150px] flex flex-col" onClick={() => { setShowTemplateList(true); }}>
              <LayoutTemplate className="!w-[40px] !h-[40px]" strokeWidth={1.25} />
              {translate("ui.selectTemplate")}
            </Button>
          </div>
        )}
      </Popup>

      <Popup
        isOpen={showPopupRedlof}
        onClose={() => { if (!isUploadingFile) setPopupRedlof(false); }}
        title={translate("ui.choose")}
        className="w-[800px]"
      >
        {isUploadingFile ? (
          <div className="h-[150px] flex items-center justify-center gap-3 text-lg font-medium">
            <Loader2 className="h-6 w-6 animate-spin" aria-hidden="true" />
            Uploading, please wait...
          </div>
        ) : (
        <div className="grid-default tmpl2">
          <Button type="button" variant="outline" className="w-full h-[150px] flex flex-col" onClick={() => { selectFile(false); }}>
            <HardDrive className="!w-[40px] !h-[40px]" strokeWidth={1.25} />
            Lokal (upload)
          </Button>
          <Button type="button" variant="outline" className="w-full h-[150px] flex flex-col" onClick={() => { selectFile(true); }}>
            <Database className="!w-[40px] !h-[40px]" strokeWidth={1.25} />
            {isLoadingRM && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />}
            RMServer02 (select)
          </Button>
        </div>)}
      </Popup>



      <Popup
        isOpen={isUndo}
        onClose={() => setUndo(false)}
        title={translate("ui.undoApproval")}
        className="w-[800px]"
      >
        <div className="">
          <div>{translate("ui.undoApprovalText")}</div>
          <br />
          <Button type="button" variant="outline" className="" onClick={() => { setSpotStatus(1); setUndo(false); }}>
            {translate("ui.undoApproval")}
          </Button>
          <Button type="button" variant="outline" className="ml-2" onClick={() => { setUndo(false); }}>
            {translate("common.cancel")}
          </Button>
        </div>
      </Popup>





      <Popup
        isOpen={errorText != ""}
        onClose={() => setError("")}
        title={translate("ui.error")}
        className=""
      >
        <div>{errorText}</div>
      </Popup>


      <Popup
        isOpen={showTemplateList}
        onClose={() => setShowTemplateList(false)}
        title={translate("ui.templates")}
        className="w-[80%]"
      >
        <Templates onClose={(templateId: string | null) => { setShowTemplateList(false); setPopup(templateId == null || templateId == ""); form.setValue('templateId', templateId); }} customerId={customerId}></Templates>
      </Popup>

      <Popup
        isOpen={fileSelectionList != null}
        onClose={() => setFileSelection(null)}
        title="Select File"
        className="w-[80%] max-h-[80vh] overflow-y-auto"
      >
        <div>
          {fileSelectionList?.map((file, index) => (
            <FolderComp
              key={index}
              source={file}
              expandedList={expandedList}
              onChange={async (value: string | number, file: string | null) => {
                if (file != null) {
                  //set selected file

                  try {

                    const res = await apiFetch(`/App/PrepareMedia?type=RM&spotId=${form.getValues('spotId')}&customerId=${customerId}&orderId=${orderId ?? ""}&aspectRatio=${form.getValues(`tbMediaFiles.${mediaIndex}.aspectRatio`)}&path=${encodeURIComponent("root\\projekte\\" + file as string)}`, { method: "POST" });
                    if (!res.ok) {
                      var error = await res.text();
                      setPopupError(error);
                      return;
                    }
                    //const url = await blobToDataURL(await res.blob());

                    var data = await res.json();
                    const media = MediaSchema.parse(data.media);
                    var indexUsed = mediaIndex;

                   /* if (isFirstFile)//find mediaindex
                    {
                      let found = false;
                      //loop through media files to find matching aspect ratio
                      for (var i = 0; i < (form.getValues("tbMediaFiles") ?? []).length; i++) {
                        if (form.getValues(`tbMediaFiles.${i}.aspectRatio`) == media.aspectRatio) {
                          setIndex(i);
                          indexUsed = i;
                          found = true;
                          break;
                        }
                      }
                      if (!found)//no match, add new media file
                      {
                        var error = translate("ui.nomediaforaspectratio") + media.aspectRatio;
                        setPopupError(error);
                        return;
                      }

                      setIsFirstFile(false);

if(data.warnings != "")
        setWarning(data.warnings);
                    }*/

                    setFileSelection(null);
                    setPopupRedlof(false);
                    setPopup(false);
                    setChanged(true);

                    form.setValue(`tbMediaFiles.${indexUsed}`, media, { shouldDirty: true, shouldTouch: true });
                    if (form.getValues("spotName") == null || form.getValues("spotName") === "") {
                      var name = file.substring(file.lastIndexOf("\\") + 1);
                      name = name.substring(0, name.lastIndexOf("."));
                      form.setValue("spotName", name, { shouldDirty: true, shouldTouch: true });
                    }
                    await setSource(media, indexUsed);
                    //form.setValue(`tbMediaFiles.${index}.fileData`, url, { shouldDirty: true, shouldTouch: true });
                    //form.setValue(`tbMediaFiles.${mediaIndex}.pathServer`, "root\\" + file as string);
                    // var type = file.toLowerCase().substring(file.lastIndexOf(".") + 1);
                    // form.setValue(`tbMediaFiles.${mediaIndex}.mimeType`, type.endsWith("mp4") || type.endsWith("wmv")? "video/" + type: "image/png");
                    // form.setValue(`templateId`, null);
                    // form.setValue("statusId", 1);
                    // setFileSelection(null);

                  } catch (e) {
                    console.error(e);
                  }




                }
                else {
                  expandedList == null ? setExpandedList([value as string]) :
                    expandedList.find(s => s == value) ? //already expanded, remove
                      setExpandedList(expandedList.filter(s => s != value)) :
                      setExpandedList([...expandedList, value as string]);
                }
              }}
            ></FolderComp>
          )
          )}


        </div>

      </Popup>







      <Popup
        isOpen={isPreview}
        onClose={() => setPreview(false)}
        title={translate("common.preview")}
        className=""

      >
        <SpotPreview onStatusChanged={(statusId: number, comment: string | null) => { updateStatus(statusId, comment);setPreview(false); }} spotId={form.getValues("spotId") as string} statusId={statusId as number}  ></SpotPreview>
      </Popup>


      <Popup
        isOpen={popupError != ""}
        onClose={() => setPopupError("")}
        title={translate("common.invalid")}
        className="w-[400px]"

      >
        <div>{popupError}</div>
      </Popup>



    </div>

  )
}



